import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3487">
      <Navbar data-id="element-3488" />
      <main data-id="element-3489">
        <ConsularAffairs data-id="element-3490" />
      </main>
      <Footer data-id="element-3491" />
    </div>;
}